import { Transition } from "@headlessui/react";
import { FC } from "react";

interface Props {
  show: boolean;
  message?: string;
  productImage: string;
  variantActive: number;
  sizeSelected: string;
  qualitySelected: number;
  messageType?: string;
}

const NotifyAddTocart: FC<Props> = ({ show, message , messageType }) => {
  const renderProductCartOnNotify = () => {
    return (
      <div className="flex ">
        <div className="ml-4 flex flex-1 flex-col">
          <div>
            <div className="flex justify-between ">
              <div>
                <p
                  className="text-base text-sm text-white"
                  style={{ fontFamily: "Roboto", color: "#0DA300" }}
                >
                  {message || "success"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Transition
      appear
      show={show}
      className="p-2 max-w-md w-full  shadow-lg rounded pointer-events-auto"
      style={{ background: "#EBFFEA", border: " 1px solid #0DA300" }}
      enter="transition-all duration-150"
      enterFrom="opacity-0 translate-x-20"
      enterTo="opacity-100 translate-x-0"
      leave="transition-all duration-150"
      leaveFrom="opacity-100 translate-x-0"
      leaveTo="opacity-0 translate-x-20"
    >
      {renderProductCartOnNotify()}
    </Transition>
  );
};

export default NotifyAddTocart;
